export enum Roles {
  // When modifying these, also modify the corresponding
  // strings in the back end.

  CLOUDPORTAL_ADMIN = 'cp-adm',
  AUTOFORM_ADMIN = 'af-adm',
  CUSTOMER_MANAGER = 'af-cusman',
}
